import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { downloadBlob } from '@shared';
import { ExportLegalPacketCommand } from './export-legal-packet.command';
import { ExportLegalPacketResult } from './export-legal-packet.result';

@Injectable({ providedIn: 'root' })
export class ExportLegalPacketUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: ExportLegalPacketCommand): Observable<ExportLegalPacketResult> {
    const today = new Date().toISOString().split('T')[0];
    const fileName = `${command.investigationNumber}-legal-packet-${today}.pdf`;

    return this._repository.exportLegalPacket(command.investigationId, command.sections).pipe(
      tap((blob: Blob) => {
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        downloadBlob(pdfBlob, fileName);
      }),
      map((): ExportLegalPacketResult => ({ success: true, fileName })),
    );
  }
}
